import APP_CONFIG from 'config/App.config';

interface IObjectKeys {
  [key: string]: string;
}

const termsConditionsLinks: IObjectKeys = {
  mafuae: 'helpcenter/articles/service/18?article=23',
  // "mafegy": '',
  // "mafsau": '',
  // "mafjor": '',
  // "mafkwt": '',
  // "maflbn": '',
  // "mafgeo": '',
  // "mafpak": '',
  // "mafken": '',
  // "mafqat": '',
  // "mafuzb": '',
};

const { storeId = 'mafuae', language = 'en' } = APP_CONFIG;
export const getCountrySpecifictermsConditionsLinks = () => {
  const href = termsConditionsLinks[storeId] || 'termsandconditions';
  return `/${storeId}/${language}/${href}`;
};
